import { FormFieldsCategory, FormValues } from 'theSource/types';

export const getInitialValues = (
  categories: FormFieldsCategory[]
): FormValues =>
  (categories || [])
    .flatMap((category) => category.fields)
    .reduce(
      (obj, item) => ({
        ...obj,
        [item.fieldName]: item.options.length
          ? item.options.find((option) => option.value === item.value)?.value ||
            ''
          : item.value,
      }),
      {}
    );

    export const getInitialValuesFromBeneficiary = (
      categories: FormFieldsCategory[],
      beneficiary?: Record<string, any>
    ): FormValues =>
      (categories || [])
        .flatMap((category) => category.fields)
        .reduce(
          (obj, item) => ({
            ...obj,
            [item.fieldName]:
              beneficiary && beneficiary[item.fieldName] !== undefined
                ? beneficiary[item.fieldName]
                : item.options.length
                ? item.options.find((option) => option.value === item.value)?.value || ''
                : item.value,
          }),
          {}
        );
